import {
  CHAT_SEND_REQUEST,
  CHAT_SEND_SUCCESS,
  CHAT_SEND_FAIL,
  CHAT_HISTORY_REQUEST,
  CHAT_HISTORY_SUCCESS,
  CHAT_HISTORY_FAIL,
  CHAT_CLEAR,
  CHAT_ADD_USER_MESSAGE,
} from "../Actions/Chat";

const initialState = {
  messages: [],
  loading: false,
  error: null,
  historyLoaded: false,
};

export const chatReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHAT_ADD_USER_MESSAGE:
      return {
        ...state,
        messages: [
          ...state.messages,
          { role: "user", content: action.payload, timestamp: new Date().toISOString() },
        ],
      };

    case CHAT_SEND_REQUEST:
      return { ...state, loading: true, error: null };

    case CHAT_SEND_SUCCESS:
      return {
        ...state,
        loading: false,
        messages: [
          ...state.messages,
          {
            role: "assistant",
            content: action.payload.message,
            timestamp: new Date().toISOString(),
            redirects: action.payload.redirects || [],
          },
        ],
        error: null,
      };

    case CHAT_SEND_FAIL:
      return {
        ...state,
        loading: false,
        messages: [
          ...state.messages,
          {
            role: "assistant",
            content: action.payload,
            timestamp: new Date().toISOString(),
            isError: true,
          },
        ],
        error: action.payload,
      };

    case CHAT_HISTORY_REQUEST:
      return { ...state, loading: true };

    case CHAT_HISTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        messages: action.payload || [],
        historyLoaded: true,
      };

    case CHAT_HISTORY_FAIL:
      return { ...state, loading: false, historyLoaded: true };

    case CHAT_CLEAR:
      return { ...initialState, historyLoaded: true };

    case "CHAT_USER_SWITCH":
    case "CHAT_LOGOUT":
      return { ...initialState };

    default:
      return state;
  }
};
